// BudgetDetails.jsx
import { AddCall as AddCallIcon, Check as CheckIcon, Done as DoneIcon, Edit as EditIcon, ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import {
	Box,
	Card,
	Collapse,
	FormControl,
	Grid,
	IconButton,
	MenuItem,
	Select,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	TextField,
	Typography
} from "@mui/material";
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { useEffect, useState } from "react";
import { MIDIA_OPTIONS_CANAL_DIRETO } from "../../../constants/midia";
import { getBudgetDetails, saveBudgetCallback, updateBudget } from "../../../services/budgetService";
import { getCallStatusOptions, getCallStatusStateOptions } from "../../../services/callCenterService";
import SidebarPhoneFormCanalDireto from "../../phone/SidebarPhoneFormCanalDireto";

const BudgetDetailsControlCanalDireto = ({ budget, fetchBudgets }) => {
	const [budgetInfo, setBudgetInfo] = useState({ details: [], retornos: [] });
	const [observacoes, setObservacoes] = useState('')
	const [selectedStatus, setSelectedStatus] = useState(0)
	const [agencia, setAgencia] = useState("");
	const [midia, setMidia] = useState("");
	const [executivo, setExecutivo] = useState("");
	const [estado, setEstado] = useState("");
	const [checkin, setCheckin] = useState("");
	const [checkout, setCheckout] = useState("");
	const [statusOptions, setStatusOptions] = useState([]);
	const [selectedMidia, setSelectedMidia] = useState(0);
	const [budgetState, setBudgetState] = useState(1)
	const [statusStateOptions, setStatusStateOptions] = useState([]);

	const midiaOptions = MIDIA_OPTIONS_CANAL_DIRETO;

	const fetchOptions = async () => {
		const options = await getCallStatusOptions(4);
		setStatusOptions(options);
		const statusStateOptions = await getCallStatusStateOptions()
		setStatusStateOptions(statusStateOptions)
	};

	const fetchData = async () => {
		let budget_type = 2
		const data = await getBudgetDetails(budget.id);
		setBudgetInfo(data);
		setObservacoes(data.observacoes)
		setSelectedStatus(data.id_status || 0)

		setAgencia(data.agencia);
		setSelectedMidia(data.midia);
		setExecutivo(data.executivo);
		setEstado(data.estado);
		setCheckin(data.check_in);
		setCheckout(data.check_out);
		setBudgetState(data.budget_status)
	};

	useEffect(() => {
		if (!budget) return;
		fetchData();
		fetchOptions();
	}, [budget]);

	const formatPrice = (price) =>
		new Intl.NumberFormat("pt-BR", {
		style: "currency",
		currency: "BRL",
		}).format(price);

	const tableCellStyle = { textAlign: "center" };

	const infoCardStyle = {
		// flex: "1 1 200px",
		display: 'flex', 
		flexDirection: 'column',
		backgroundColor: "#fff",
		border: "1px solid #eee",
		borderRadius: 2,
		p: "6px 12px",
		boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
		// margin: "6px 2px",
		minHeight: '60px',
		maxHeight: 'max-content'
	};

	const labelStyle = {
		textTransform: "uppercase",
		fontWeight: 500,
		letterSpacing: "0.05em",
		color: "#6b7280",
	};

	const infoDetailStyle = {
		flex: "1",
		backgroundColor: "#fff",
		border: "1px solid #eee",
		borderRadius: 2,
		p: "6px 12px",
		boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
		margin: "6px 0px"
	};

	const labelDetailStyle = {
		textTransform: "uppercase",
		fontWeight: 500,
		letterSpacing: "0.05em",
		color: "#6b7280",
	};

	const boxDetailStyle = {
		marginBottom: "40px"
	};

	const [editarOrcamento, setEditarOrcamento] = useState(false)

	const handleEditOrcamento = () => {
		setEditarOrcamento(true)
	}

	const handleSubmitBudgetUpdate = async () => {
		if(budgetInfo.observacoes !== observacoes || 
		budgetInfo.id_status !== selectedStatus || 
		budgetInfo.agencia !== agencia || 
		budgetInfo.midia !== midia || 
		budgetInfo.executivo !== executivo || 
		budgetInfo.estado !== estado){	

			const budgetObj = {
				observacoes: observacoes,
				id_status: selectedStatus,
			}

			const detailsObj = {
				agencia: agencia,
				midia: selectedMidia,
				executivo: executivo,
				estado: estado,
				// check_in: checkin,
				// check_out: checkout,
			}

			const data = {
				budget_id: budgetInfo.budget_id,
				budget_type: 2,
				newBudgetData: budgetObj,
				newDetailsData: detailsObj
			}

			await updateBudget(data)
			fetchData()
			fetchBudgets()
		}
		setEditarOrcamento(false)
	}

	const iconButtonStyle = {
		display: "flex",
    	alignItems: "center",
		gap: "5px",
		"&:hover": {
			cursor: "pointer",
			opacity: '0.8'
		}
	}

	const [openDrawer, setOpenDrawer] = useState(false);
	const toggleDrawer = () => setOpenDrawer((prev) => !prev);

	const submitPhoneForm = async (formData) => {
		const [day, month, year] = formData.dtRetorno.split('/');
		const dt_retorno = new Date(Number(year), Number(month) - 1, Number(day));

		const callbackObj = {
			budget_request_id: budget.id,
			dt_retorno,
			midia: formData.selectedMidia
		}

		const budgetObj = {
			observacoes: formData.observacoes,
			id_status: formData.selectedStatus,
		}

		const detailsObj = {
			agencia: agencia,
			midia: formData.selectedMidia,
			executivo: executivo,
			estado: estado,
			check_in: checkin,
			check_out: checkout,
		}

		const data = {
			budget_id:	budget.id,
			budget_type: 2,
			register_type: 'budget_request',
			callbackObj,
			newBudgetData: budgetObj,
			newDetailsData: detailsObj
		}

		const res = await saveBudgetCallback(data)
		fetchData()
		fetchBudgets()
	}

	const handleChangeStatus = (id_status) => {
		setSelectedStatus(id_status)
		if (id_status === 0){
			setBudgetState({id_state: 0, color: "#e2e2e2"})
			return
		}

		const statusObj = statusOptions.find(status => id_status === status.id)
		const stateObj = statusStateOptions.find(state => statusObj.id_state === state.id_state)

		setBudgetState(stateObj)
	}

  	const [open, setOpen] = useState(false);

	const formatPhoneNumberIntl = (number) => {
		try {
			const phoneNumber = parsePhoneNumberFromString(number);
			return phoneNumber ? phoneNumber.formatInternational() : number;
		} catch (e) {
			return number;
		}
	}

	return (
		<Card id="card-details">
            <SidebarPhoneFormCanalDireto open={openDrawer} onClose={toggleDrawer} handleSubmit={submitPhoneForm} budgetInfo={budgetInfo} statusOptions={statusOptions}/>
            {/* {
              !openDrawer && <SidebarPhoneFab onClick={toggleDrawer} />
            } */}
			<Box sx={{ p: 3, minWidth: 1050, backgroundColor: "#f9fafb", borderBottom: "1px solid #eee" }}>
				<Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: "space-between", gap: '15px', mb: 2}}>
					<Typography variant="h2" sx={{ fontWeight: 600, display: "flex", alignItems: "center", gap: "10px"}}>
						Detalhes do Orçamento
						<Box
							component="span"
							sx={{
								width: 32,
								height: 32,
								borderRadius: "50%",
								bgcolor: budgetState.color,
								flexShrink: 0
							}}
						/>
						{
							editarOrcamento ? (
								<DoneIcon
									sx={{ ...iconButtonStyle, fontSize: '24px', color: 'green' }}
									onClick={handleSubmitBudgetUpdate}
								/>
							) : (
								<EditIcon
									sx={{
										...iconButtonStyle,
										fontSize: '24px',
										color: openDrawer ? 'grey' : 'inherit',
										pointerEvents: openDrawer ? 'none' : 'auto',
										opacity: openDrawer ? 0.5 : 1,
									}}
									onClick={!openDrawer ? handleEditOrcamento : undefined}
								/>
							)
						}
					</Typography>
					<Typography
						variant="h4"
						sx={{
							...iconButtonStyle,
							color: editarOrcamento ? 'grey' : 'green',
							pointerEvents: editarOrcamento ? 'none' : 'auto',
							opacity: editarOrcamento ? 0.5 : 1,
						}}
						onClick={!editarOrcamento ? toggleDrawer : undefined}
					>
						<AddCallIcon sx={{ fontSize: '32px' }} />
						Adicionar retorno
					</Typography>
				</Box>
				<Grid container size={14} rowSpacing={'6px'} columnSpacing={'12px'} marginBottom={'6px'}>
					<Grid item size={3} sx={infoCardStyle}>
						<Typography variant="h5" sx={{...labelStyle, fontWeight: 600 }}>
							Cliente
						</Typography>
						<Typography variant="body1">{budget.client}</Typography>
					</Grid>
					<Grid item size={3} sx={infoCardStyle}>
						<Typography variant="h5" sx={{...labelStyle, fontWeight: 600 }}>
							Telefone
						</Typography>
						<Typography variant="body1">{formatPhoneNumberIntl(budget.phone)}</Typography>
					</Grid>
					<Grid item size={6} sx={{...infoCardStyle}}>
						<Typography variant="h5" sx={{...labelStyle, fontWeight: 600 }}>
							Email
						</Typography>
						<Typography variant="body1">{budget.email}</Typography>
					</Grid>
					<Grid item size={3} sx={infoCardStyle}>
						<Typography variant="caption" sx={labelStyle}>
							Operador
						</Typography>
						<Typography variant="body1">{budget.clerk}</Typography>
					</Grid>
					<Grid item size={3} sx={infoCardStyle}>
						<Typography variant="caption" sx={labelDetailStyle}>
							Check-in
						</Typography>
						<Typography variant="body1">{checkin}</Typography>
					</Grid>
					<Grid item size={3} sx={infoCardStyle}>
						<Typography variant="caption" sx={labelDetailStyle}>
							Check-out
						</Typography>
						<Typography variant="body1">{checkout}</Typography>
					</Grid>
					<Grid item size={3} sx={infoCardStyle}>
						<Typography variant="caption" sx={labelStyle}>
							Data de Envio
						</Typography>
						<Typography variant="body1">{budget.created_at}</Typography>
					</Grid>
				</Grid>
				{editarOrcamento ? 
					<Grid container size={14} rowSpacing={'6px'} columnSpacing={'12px'}>
						<Grid item size={3} sx={infoCardStyle}>
							<Typography variant="caption" sx={labelStyle}>Agência</Typography>
							<TextField value={agencia} onChange={(e) => setAgencia(e.target.value)} />
						</Grid>
						<Grid item size={3} sx={infoCardStyle}>
							<Typography variant="caption" sx={labelStyle}>Estado</Typography>
							<TextField value={estado} onChange={(e) => setEstado(e.target.value)} />
						</Grid>
						<Grid item size={3} sx={infoCardStyle}>
							<Typography variant="caption" sx={labelStyle}>Executivo</Typography>
							<TextField value={executivo} onChange={(e) => setExecutivo(e.target.value)} />
						</Grid>
						<Grid item size={3} sx={{...infoCardStyle}}>
							<Typography variant="caption" sx={labelStyle}>
								Motivo do acompanhamento
							</Typography>
							<FormControl>
								<Select
								value={selectedStatus}
								onChange={e => handleChangeStatus(e.target.value)}
								sx={{
									fontWeight: !selectedStatus ? 600 : 500,
									fontFamily: 'Montserrat',
								}}
								>
								<MenuItem value={0} sx={{ fontWeight: 600, fontFamily: 'Montserrat' }}>
									Selecione o motivo do acompanhamento
								</MenuItem>
								{statusOptions.map(item => (
									<MenuItem
									key={item.id}
									value={item.id}
									sx={{ fontWeight: 500, fontFamily: 'Montserrat' }}
									>
									{item.ds_status}
									</MenuItem>
								))}
								</Select>
							</FormControl>
						</Grid>
						<Grid item size={3} sx={{...infoCardStyle}}>
							<Typography variant="caption" sx={labelStyle}>Mídia</Typography>
							<FormControl>
								<Select
									labelId="midia-label"
									value={selectedMidia}
									onChange={e => setSelectedMidia(e.target.value)}
									sx={{
										fontWeight: !selectedMidia ? 600 : 500,
										fontFamily: 'Montserrat',
									}}
								>
									<MenuItem
										value={0}
										sx={{
											fontWeight: 600,
											fontFamily: 'Montserrat',
										}}
									>
										Selecione uma mídia
									</MenuItem>
									{midiaOptions.map(midia => (
										<MenuItem
											key={midia.id}
											value={midia.ds_midia}
											sx={{
												fontWeight: 500,
												fontFamily: 'Montserrat',
											}}
										>
											{midia.ds_midia}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						</Grid>
						<Grid item size={6} sx={{...infoCardStyle}}>
							<Typography variant="caption" sx={labelStyle}>
								Observações
							</Typography>
							<TextField
								multiline
								value={observacoes}
								onChange={(e) => setObservacoes(e.target.value)}
							/>
						</Grid>
					</Grid>
					:
					<Grid container size={12} rowSpacing={'6px'} columnSpacing={'12px'}>
						<Grid item size={3} sx={infoCardStyle}>
							<Typography variant="caption" sx={labelStyle}>Agência</Typography>
							<Typography variant="body1">{budgetInfo.agencia}</Typography>
						</Grid>
						<Grid item size={3} sx={infoCardStyle}>
							<Typography variant="caption" sx={labelStyle}>Estado</Typography>
							<Typography	variant="body1">{budgetInfo.estado}</Typography>
						</Grid>
						<Grid item size={3} sx={infoCardStyle}>
							<Typography variant="caption" sx={labelStyle}>Executivo</Typography>
							<Typography variant="body1">{budgetInfo.executivo}</Typography>
						</Grid>
						<Grid item size={3} sx={infoCardStyle}>
							<Typography variant="caption" sx={labelStyle}>
								Motivo do acompanhamento
							</Typography>
							<Typography variant="body1">{budgetInfo.ds_status}</Typography>
						</Grid>
						<Grid item size={3} sx={infoCardStyle}>
							<Typography variant="caption" sx={labelStyle}>Mídia</Typography>
							<Typography variant="body1">{budgetInfo.midia}</Typography>
						</Grid>
						<Grid item size={6} sx={infoCardStyle}>
							<Typography variant="caption" sx={labelStyle}>
								Observações
							</Typography>
							<Typography variant="body1">{budgetInfo.observacoes}</Typography>
						</Grid>
						<Grid item size={3}></Grid>
					</Grid>		
				}
				{budgetInfo.retornos.length > 0 && (
					<Box>
						<Grid container>
							<Grid item size={12} sx={{display: "flex", flexDirection: "row", alignItems: 'center'}}>
								<Typography variant="h4" sx={{ fontWeight: 500, margin: 0 }}>
									Lista de Retornos
								</Typography>
								{budgetInfo.retornos.length > 1 && (
									<IconButton onClick={() => setOpen(prev => !prev)}>
										{open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
									</IconButton>
								)}
							</Grid>
						</Grid>
						<Grid container key={budgetInfo.retornos[0].id_retorno}>
							<Grid item size={3} sx={infoCardStyle}>
								<Typography variant="caption" sx={labelStyle}>Mídia</Typography>
								<Typography variant="body1">{budgetInfo.retornos[0].midia}</Typography>
							</Grid>
							<Grid item size={3} sx={infoCardStyle}>
								<Typography variant="caption" sx={labelStyle}>Data de Retorno</Typography>
								<Typography variant="body1">{budgetInfo.retornos[0].dt_retorno}</Typography>
							</Grid>
							<Grid item size={6}>
							</Grid>
						</Grid>

						{budgetInfo.retornos.length > 1 && (
							<Grid container>
								<Grid item size={12}>
									<Collapse in={open}>
										{budgetInfo.retornos.slice(1).map(retorno => (
										<Grid container key={retorno.id_retorno}>
											<Grid item size={3} sx={infoCardStyle}>
											<Typography variant="caption" sx={labelStyle}>Mídia</Typography>
											<Typography variant="body1">{retorno.midia}</Typography>
											</Grid>
											<Grid item size={3} sx={infoCardStyle}>
											<Typography variant="caption" sx={labelStyle}>Data de Retorno</Typography>
											<Typography variant="body1">{retorno.dt_retorno}</Typography>
											</Grid>
											<Grid item size={6}></Grid>
										</Grid>
										))}
									</Collapse>
								</Grid>
							</Grid>
						)}
					</Box>
					)}
			</Box>
			<Box sx={{ p: 3, minWidth: 1050 }}>
				<Typography variant="h4" gutterBottom sx={{ fontWeight: 500 }}>
					Detalhes das Diárias
				</Typography>
				{budgetInfo.details.map((d) => (
					<Box key={d.id} sx={boxDetailStyle}>
						<Table size="small">
							<TableHead>
								<TableRow sx={{ backgroundColor: "#f3f4f6" }}>
									<TableCell sx={tableCellStyle}>Acomodação</TableCell>
									<TableCell sx={tableCellStyle}>Preço</TableCell>
									<TableCell sx={tableCellStyle}>Indisponível</TableCell>
								</TableRow>
							</TableHead>
							{d.accommodations.map((uh) => (
								<TableBody>
									<TableRow key={d.id} hover>
										<TableCell sx={tableCellStyle}>{uh.uh_type}</TableCell>
										<TableCell sx={tableCellStyle}>{formatPrice(uh.price)}</TableCell>
										<TableCell sx={tableCellStyle}>
											{uh.flg_nao_disponivel ? <CheckIcon sx={{ fill: "black" }} /> : ""}
										</TableCell>
									</TableRow>
								</TableBody>
							))}
						</Table>
					</Box>
				))}
			</Box>
		</Card>
	);
};


export default BudgetDetailsControlCanalDireto;
